import { Button } from '@mui/material'
import CheckBox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const ImportProspectSubTitle = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
  width: 250px;
`

export const ImportProspectsTitle = styled(Typography)`
  padding-bottom: 10px;
`

export const FilterOptionContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 30px;
`

export const FilterAllContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
`

export const FilterSectionContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const FilterOptionLabel = styled(Typography)`
  display: inline-flex;
  gap: 6px;
  span {
    line-height: 1;
  }
`

export const FilterOptionCheckbox = styled(CheckBox)(({ $color }: { $color?: string }) => ({
  color: $color,
  borderColor: $color || '#A4A4A4',
  padding: 0,

  '&.Mui-checked': {
    color: $color,
  },
}))

export const CustomButton = styled(Button)`
  height: 28px;
  border: 1px solid #cfcfcf;
  background-color: #fafafa;
  color: ${colors.bodyText};

  &:hover {
    border: 1px solid #cfcfcf;
    background-color: #fafafa;
    color: ${colors.bodyText};
  }
`

export const ProspectsSelectionViewWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  height: 100%;
  max-height: 620px;
`

export const ProspectFiltersBox = styled('div')`
  display: flex;
  flex-direction: column;
  width: 284px;
`

export const ProspectsContainerBox = styled('div')`
  border-radius: 8px;
  border: 1px solid #e6e6e6;
  background: #fafafa;
  padding: 16px;
  margin-left: 16px;
  width: 284px;
  overflow: auto;
`

export const ImportProspectsHeadBox = styled('div')`
  flex: 0 0 auto;
`

export const ImportProspectsScrollContainer = styled('div')`
  flex: 1 1 auto;
  overflow: auto;
  ${(props: { $withScrollBar?: boolean }) => props.$withScrollBar && 'padding-right: 15px;'}
`
export const ImportProspectsBottomBox = styled('div')`
  flex: 0 0 auto;
`

export const ProspectTagsContainer = styled('div')`
  display: flex;
  margin-right: 10px;
`

interface ProspectTagDotProps {
  $color: string
}

export const ProspectTagDot = styled('div')`
  width: 8px;
  height: 8px;
  background: ${({ $color }: ProspectTagDotProps) => $color};
  border: 1px solid ${colors.white};
  border-radius: 50%;
  box-sizing: content-box;
  margin-left: -3px;
  margin-top: -1px;
`
